export var KEEN_TABLE_ANALYSIS = 'analysis';
export var KEEN_TABLE_VALUE = 'value';
